export enum EnumCSKPISPageNames {
  CSK_CREATE = "cs_kpis_create"
}
